export default {
    methods: {
        getPlaceholder(field) {
            return field.labelData?.option_type === 'dropdown'
                ? trans('custom.select')
                : field.label;
        },
        populateForm() {
            const formValues = this.generateFormValues();
            this.validateFormValues(formValues);
            return formValues;
        },
        validateFormValues(formValues) {
            for (let i = 0; i < formValues.length; i++) {
                const options = _.get(formValues[i], 'labelData.options', []);
                if (options.length) {
                    const type = _.get(formValues[i], 'labelData.type', '').toLowerCase();
                    if (formValues[i].value !== '' && type === 'range') {
                        if (parseInt(formValues[i].value) > parseInt(options[1].option)) {
                            formValues[i].value = options[1].option;
                        } else if (parseInt(formValues[i].value) < parseInt(options[0].option)) {
                            formValues[i].value = options[0].option;
                        }
                    }
                    if ((formValues[i].labelData?.option_type === 'dropdown' || type === 'multiple')
                        && !_.some(options, { option: formValues[i].value })) {
                        formValues[i].value = null;
                    }
                }
            }
        },
        getExistingValue(field, value) {
            let customValue;
            if (_.isBoolean(value) || _.isNumber(value)) {
                customValue = value;
            } else {
                customValue = value || null;
            }
            return customValue && _.cloneDeep(customValue);
        },
        setValue({ value, localId }) {
            const fieldValue = this.findFieldValue(localId);
            const options = fieldValue.labelData?.options;
            const labelType = fieldValue.labelType;

            if (labelType === 'checkbox' && typeof value === 'boolean') {
                if (options) {
                    options[0].checked = value;
                }
                return fieldValue.value = value;
            } else if (labelType === 'checkboxes' && _.isArray(value)) {
                if (options) {
                    options.forEach((option) => option.checked = value.includes(option.index));
                }
                fieldValue.value = options.filter(option => value.includes(option.index)).map(option => option.option);
                fieldValue.valueRaw = _.isEmpty(value) ? null : value;
            }
            return fieldValue.value = _.isNumber(value) || value ? value : null;
        },
        findCustomValuesOnModel(e, type, subType = null) {
            if (_.has(nal, `${type}.data`)) {
                _(nal[type].data).forEach(model => {
                    if (model[subType]?.data) {
                        model[subType].data.forEach(item => {
                            this.removeCustomValuesOnModel(e, item, subType);
                        });
                    }
                    this.removeCustomValuesOnModel(e, model, type);
                });
            }
        },
        removeCustomValuesOnModel(e, model) {
            const customValues = model.manager?.customValues;
            if (customValues) {
                const customValueIndex = _(customValues).findIndex([
                    'field.id',
                    +e.id,
                ]);
                if (~customValueIndex) {
                    customValues.splice(customValueIndex, 1);
                }
            }
        },
    },
};
